<!--
 * @Author: your name
 * @Date: 2021-08-09 15:14:26
 * @LastEditTime: 2021-09-07 11:35:47
 * @LastEditors: DESKTOP-0USOKJQ
 * @Description: In User Settings Edit
 * @FilePath: \sp-site-front\src\App.vue
-->
<template>
  <div>
    <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
import store from "@/store/index"
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  data(){
    return{
      isRouterAlive:true
    }
  },
  mounted: function () {
    //此方法刷新页面时也会执行
    // window.addEventListener('beforeunload',()=>{
    //   store.commit("$_removeToken");
    //   store.commit("$_removeUserName");
    // });
  },
  methods:{
     reload (){
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue